import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import DomainManagementBulkForm from './domain-management-bulk-form';
import DomainManagementBulkErrors from './domain-management-bulk-errors';

const DomainManagementBulkContent = ( {
    domainErrors,
    domainList,
    domainListErrorMessage,
    domainActionType,
    domainTypeSelected,
    onChangeDomainActionType,
    onChangeDomainList,
    onChangeDomainType
} ) => {
    if( !isEmpty( domainErrors ) && Object.keys( domainErrors ).length > 0 ){
        return <DomainManagementBulkErrors domainErrors={domainErrors} domainActionType={domainActionType} />;
    }

    return (
        <DomainManagementBulkForm
            domainActionType={domainActionType}
            domainList={domainList}
            domainListErrorMessage={domainListErrorMessage}
            domainTypeSelected={domainTypeSelected}
            onChangeDomainActionType={onChangeDomainActionType}
            onChangeDomainList={onChangeDomainList}
            onChangeDomainType={onChangeDomainType}
        />
    );
};

DomainManagementBulkContent.propTypes = {
    domainActionType: PropTypes.string,
    domainErrors: PropTypes.object,
    domainList: PropTypes.string,
    domainListErrorMessage: PropTypes.string,
    domainTypeSelected: PropTypes.string,
    onChangeDomainActionType: PropTypes.func.isRequired,
    onChangeDomainList: PropTypes.func.isRequired,
    onChangeDomainType: PropTypes.func.isRequired,
};

export default DomainManagementBulkContent;
